import SkipRepeatedContentSnippet from "snippets/skip-repeated-content.mdx";
import * as React from 'react';
export default {
  SkipRepeatedContentSnippet,
  React
};